export default "__VITE_ASSET__DrjxHMgz__"